var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 21.3426V64.6759M40.5 21.3426C36.607 18.7562 31.3216 17.1666 25.5 17.1666C19.6784 17.1666 14.393 18.7562 10.5 21.3426V64.6759C14.393 62.0895 19.6784 60.5 25.5 60.5C31.3216 60.5 36.607 62.0895 40.5 64.6759M40.5 21.3426C44.393 18.7562 49.6784 17.1666 55.5 17.1666C61.3216 17.1666 66.607 18.7562 70.5 21.3426V64.6759C66.607 62.0895 61.3216 60.5 55.5 60.5C49.6784 60.5 44.393 62.0895 40.5 64.6759",
    stroke: "#345658",
    strokeWidth: 6.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCreate);
export default __webpack_public_path__ + "static/media/Btn_Create.e1430a48fc1d0c581af529be320b3d1a.svg";
export { ForwardRef as ReactComponent };